import {
  Home,
  Library,
  CalendarDays,
  LineChart,
  BookOpen,
  User,
} from "lucide-react";

const tabs = [
  {
    icon: <Home className="w-5 h-5" />,
    name: "Home",
    desc: "Today's training & readiness at a glance.",
  },
  {
    icon: <Library className="w-5 h-5" />,
    name: "Programs",
    desc: "Browse 250+ structured programs by sport, goal & level.",
  },
  {
    icon: <CalendarDays className="w-5 h-5" />,
    name: "Calendar",
    desc: "Scheduled sessions and weekly training plan.",
  },
  {
    icon: <LineChart className="w-5 h-5" />,
    name: "Progress",
    desc: "Dashboards, charts, body composition & assessments.",
  },
  {
    icon: <BookOpen className="w-5 h-5" />,
    name: "Library",
    desc: "200+ exercises with cues, demos & coaching notes.",
  },
  {
    icon: <User className="w-5 h-5" />,
    name: "Profile",
    desc: "Subscription, settings, privacy & account.",
  },
];

export default function InsideTheAppSection() {
  return (
    <section
      id="inside-app"
      className="relative nfp-section bg-[#0a0a0a]"
      data-testid="section-inside-app"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <p className="text-[11px] tracking-[0.3em] uppercase text-[#1FA2FF] mb-4">
              Inside the App
            </p>
            <h2 className="nfp-heading text-white text-4xl md:text-6xl leading-[1] tracking-tight">
              Six tabs. <br />
              Everything you need to <span className="text-[#00E5FF]">train</span>.
            </h2>
          </div>
          <p className="md:max-w-sm text-white/60 leading-relaxed">
            Designed to feel like a coach in your pocket — clean iOS navigation
            built for athletes who want signal, not noise.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
          {tabs.map((t, i) => (
            <div
              key={t.name}
              data-testid={`tab-${t.name.toLowerCase()}`}
              className="group relative rounded-2xl border border-white/10 bg-[#0c0c0c] p-5 hover:border-[#1FA2FF]/40 transition-all"
            >
              <div className="w-11 h-11 rounded-xl bg-[#1FA2FF]/10 border border-[#1FA2FF]/30 text-[#00E5FF] flex items-center justify-center">
                {t.icon}
              </div>
              <p className="mt-4 nfp-mono text-[10px] text-[#1FA2FF]">
                0{i + 1}
              </p>
              <h3 className="nfp-heading text-white text-xl mt-1 tracking-tight">
                {t.name}
              </h3>
              <p className="text-xs text-white/55 mt-2 leading-relaxed">
                {t.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
